// @ts-nocheck
import { createHandlerChainRunner, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { GetProductByPathApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";

type Parameter = {
    path: string;
    addToRecentlyViewed?: boolean;
} & HasOnSuccess<ProductModel> &
    HasOnError<string>;
type Props = {
    apiParameter: GetProductByPathApiV2Parameter;
    apiResult: ProductModel;
};

type HandlerType = Handler<Parameter, Props>;

export const StorePopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
        expand: [
            "detail",
            "specifications",
            "content",
            "images",
            "documents",
            "attributes",
            "variantTraits",
            "badges",
            "properties",
        ],
        includeAttributes: ["includeOnProduct", "notFromCategory"],
    };
};

replaceInChain(chain, PopulateApiParameter, StorePopulateApiParameter);

const loadProductByPath = createHandlerChainRunner(chain, "LoadProductByPath");
export default loadProductByPath;
